/*
  PDP product gallery settings.
  Loads straight after vendor.js, before theme-v3.js builds any slider,
  so these settings are in place from the first frame.

  - No looping: image 1 can only go forward to image 2
  - No bounce when dragging past the first or last image
  - No back arrow on the first image
  - Swipe starts after 10px sideways movement (was 3px), so page scrolling doesn't grab the gallery
*/
(function () {
  var vendor = window.themeVendor;
  if (!vendor || !vendor.Flickity) return;

  var DRAG_THRESHOLD = 10;

  function isProductGallery(element) {
    return element && element.hasAttribute && element.hasAttribute('data-product-slideshow');
  }

  function patchPrototype(proto) {
    if (!proto || proto.__commaGalleryPatched) return;
    proto.__commaGalleryPatched = true;

    var originalCreate = proto._create;
    var originalDragMove = proto.handleDragMove;

    // Set the gallery options before the slider is built
    proto._create = function () {
      if (isProductGallery(this.element)) {
        this.options.wrapAround = false;
        this.options.contain = true;
        this.options.dragThreshold = DRAG_THRESHOLD;
        this.options.noBounce = true;
      }
      return originalCreate.apply(this, arguments);
    };

    // Stop the drag at the first and last image instead of stretching past them
    proto.handleDragMove = function () {
      originalDragMove.apply(this, arguments);
      if (!this.options.noBounce || !this.slides || !this.slides.length) return;
      var firstPos = -this.slides[0].target;
      var lastPos = -this.slides[this.slides.length - 1].target;
      if (this.dragX > firstPos) this.dragX = firstPos;
      if (lastPos > this.dragX) this.dragX = lastPos;
    };
  }

  patchPrototype(vendor.Flickity.prototype);
  if (vendor.FlickityFade && vendor.FlickityFade.prototype !== vendor.Flickity.prototype) {
    patchPrototype(vendor.FlickityFade.prototype);
  }

  // Styles: hide the back arrow on the first image, stop iOS image drag/callout
  var style = document.createElement('style');
  style.textContent =
    '.product__slides .flickity-prev-next-button.previous:disabled { display: none !important; }' +
    '.product__slides .flickity-slider { will-change: transform; }' +
    '.product__slides img { -webkit-user-drag: none; -webkit-user-select: none; user-select: none; -webkit-touch-callout: none; }' +
    '.product__slides .lazy-image { -webkit-tap-highlight-color: transparent; }';
  document.head.appendChild(style);

  // Load the rest of the gallery images once the page has loaded, so swiping never shows a blank image
  window.addEventListener('load', function () {
    document.querySelectorAll('[data-product-slideshow] img.lazyload').forEach(function (img) {
      if (window.lazySizes && window.lazySizes.loader) {
        window.lazySizes.loader.unveil(img);
      } else {
        img.classList.add('lazypreload');
      }
    });
  });
})();
